module.exports = __webpack_public_path__ + "img/jbabdi_saad.0d54820c.png";